/* import __COLOCATED_TEMPLATE__ from './sh-download-as-csv.hbs'; */
import { scheduleOnce } from '@ember/runloop';
import Component from '@ember/component';
import { observer } from '@ember/object';

export default Component.extend({
  tagName: 'a',
  classNames: ['download-as-csv', 'btn'],
  classNameBindings: ['disabled'],
  attributeBindings: ['href', 'download'],

  disabled: true,
  href: null,
  download: 'accounts-aging.csv',

  isLoading: undefined,
  csvData: undefined,
  tableSelector: undefined,

  isLoadingWatcher: observer('isLoading', function(){
    if(this.get('isLoading') === false) {
      this._initializeElement();
    } else {
      this.set('disabled', true);
      this.set('href', null);
    }
  }),

  click(e) {
    if(this.get('disabled') === true) {
      return false;
    } else {
      return true;
    }
  },

  _generateCSVString(){
    let csvData = this.get('csvData');
    let csvString = "data:text/csv;charset=utf-8,";

    csvData.forEach((rowArray, rowIndex) => {
      let rowString = rowArray.join(",");
      csvString += (rowIndex  !== csvData.length-1) ? `${rowString}\n` : rowString;
    });

    return csvString;
  },

  _initializeElement() {
    if(this.get('csvData')){
      this.set('href', encodeURI(this._generateCSVString()));
      this.set('disabled', false);

    } else if(this.get('tableSelector')){
      let tableSelector = this.get('tableSelector');
      let table = document.querySelector(tableSelector);

      if(table) {
        let csvData = [];
        table.querySelectorAll('tr').forEach((row, rowIndex) => {
          csvData.push([]);

          row.querySelectorAll('th, td').forEach((element) => {
            csvData[rowIndex].push(`"${element.textContent}"`);
          });
        });

        this.set('csvData', csvData);
        this.set('href', encodeURI(this._generateCSVString()));
        this.set('disabled', false);
      }
    }
  },

  didInsertElement() {
    scheduleOnce('afterRender', this, function() {
      if(this.get('isLoading') === false){
        this._initializeElement();
      }
    });
  }
});
